export enum AppInsightsEvent {
	BootCompleted = "boot_completed",
	FatalError = "fatal_error",
	AppReady = "app_ready",
	RedirectToNotFound = "redirect.not_found",
	RedirectToUnsupportedBrowser = "redirect.unsupported_browser",
	RedirectToDisabledFeatures = "redirect.disabled_features",
	RedirectToMaintenanceMode= "redirect.maintenance_mode",
	RedirectToHome = "redirect.home",
	RedirectToHomeError = "error.redirect_to_home",
	RedirectToChannelMismatch = "redirect.channel_mismatch",
	FlowStarted = "flow.started",
	FlowNextStep = "flow.next_step",
	FlowPreviousStep = "flow.previous_step",
	FlowResume = "flow.resume",
	FlowEndByUser = "flow.end_by_user",
	FlowEndSuccessful = "flow.end_successful",
	FlowEndUnsuccessful = "flow.end_unsuccessful",
	SaveBowlersOptions = "webres.save_bowlers_options",
	CartOpened = "cart.opened",
	CartClosed = "cart.closed",
	ContinueFromCartSidebarClicked = "cart.continue_from_sidebar_clicked",
	CheckoutFromCartSidebarClicked = "cart.checkout_from_sidebar_clicked",
	CartReduceItemQuantity = "cart.reduce_item_quantity",
	CartIncreaseItemQuantity = "cart.increase_item_quantity",
	CartRemoveItem = "cart.remove_item",
	CartBackToStep = "cart.back_to_step",
	ReservationCreated = "webres.created",
	ReservationResumeAsk = "webres.resume_ask",
	ReservationResumeAccepted = "webres.resume_accepted",
	ReservationResumeCanceled = "webres.resume_canceled",
	ReservationTimeoutAfterConfirmPayment = "webres.timeout_after_confirm_payment",
	ReservationTimeoutAfterClosePaymentPopup = "webres.timeout_after_close_payment_popup",
	ReservationTokenMissingOnCreate = "webres.token_is_missing_create",
	ReservationTokenMissingOnRenew = "webres.token_is_missing_renew",
	UserClosedPaymentPopup = "payment.user_closed_popup",
	UserClosedPaymentModal = "payment.user_closed_modal",
	UserLeftPaymentModal = "payment.user_left_modal",
	UserLoginSuccessful = "login.successful",
	UserLoginError = "login.error",
	CartConfirmed = "cart.confirmed",
	PaymentStart = "payment.start",
	PaymentError = "payment.error",
	PaymentSuccessful = "payment.successful",
	PaymentUnsuccessful = "payment.unsuccessful",
	PaymentModalOpen = "payment.user_opened_modal",
	PaymentRollback = "payment.rollback_called",
	PaymentLinkInvalid= "payment.invalid_payment_link",
	IndexedDBFailure = "error.indexedDb_failure",
	FluxNavigationError = "error.flux_navigation",
	UserOpenedGuestModal = "user.guest_modal.was_opened",
	UserClosedGuestModal = "user.guest_modal.was_closed",
	UserClickedTimeSlot = "user.carousel.time-slot_clicked",
	UserClickedCheckAvailability = "user.check_availability_clicked",
	SuperTouchExtendYourPlayQRScanned = "external_pos.square.supertouch_scanned_eyp_qrcode",
	// MA Events
	AttractionItemSelected = "multi_attraction.item_selected",
	AttractionReservationTokenMissingOnCreate = "multi_attraction.token_is_missing_create",
	RedirectToAttractionHome = "multi_attraction.redirect_home_attraction",
	RedirectToBowlingHome = "multi_attraction.redirect_home_bowling",
	// Bowling Memories Events
	BowlingMemoriesLanding = "bowling_memories.landing",
	BowlingMemoriesSharePage = "bowling_memories.share_page",
	BowlingMemoriesShareError = "bowling_memories.share_error",
	BowlingMemoriesBookAgainClicked = "bowling_memories.book_again_clicked",
	// Dev Settings Events
	CustomizedBackendUrl = "settings.backend_url_changed"
}
